module.exports = __webpack_public_path__ + "static/img/bg-ar.1373bba1.png";